export default __webpack_public_path__ + "static/media/Spin general_Interactive LightMix0061.745436d2.webp";